
const createMightyExProduct = (data: any) => ({
  ...data,
  price: 0,
  status: '재고있음',
  category: 'HYUNDAI MIGHTY EX',
  compatibleVehicles: ['MIGHTY EX'],
  colors: data.colors || ['#808080'],
  images: [],
  features: [
    { icon: 'ri-shield-check-line', title: '순정 규격', description: '완벽한 호환성' },
    { icon: 'ri-tools-line', title: '간편 설치', description: '볼트온 장착' },
    { icon: 'ri-star-line', title: '고품질', description: '내구성 보장' },
    { icon: 'ri-checkbox-circle-line', title: '품질 보증', description: '안심 사용' },
  ],
  craftStory: {
    // Added a forward slash before “craft” to make the URL valid and avoid syntax issues
    image: `https://public.readdy.ai/ai/img_res/90d9aafa5f90b4e2cb9ebd506fbc2063.jpg${data.id}/craft&orientation=landscape`,
    story: `HYUNDAI MIGHTY EX의 ${data.description}입니다.`,
    details: ['순정 규격 제작', '고품질 소재', '내구성 보장', '완벽한 호환'],
  },
});

export const mightyExProducts = [
  createMightyExProduct({
    id: 'HDM001',
    name: 'HDM001',
    description: 'HEAD LAMP',
    subcategory: '램프',
    partNumber: '92101-6A000 L / 92102-6A000 R',
    fullDescription: '현대 MIGHTY EX에 호환되는 헤드 램프입니다. 순정 규격으로 제작되어 완벽한 호환성을 제공합니다.',
    image: 'https://readdy.ai/api/search-image?query=Hyundai%20Mighty%20EX%20commercial%20truck%20head%20lamp%20clear%20lens%20large%20rectangular%20chrome%20housing%20on%20clean%20white%20background%20automotive%20lighting%20spare%20part%20product%20photography%20studio%20lighting%20professional%20shot&width=800&height=1000&seq=hdm001main&orientation=portrait',
    colors: ['#C0C0C0'],
  }),
  createMightyExProduct({
    id: 'HDM002',
    name: 'HDM002',
    description: 'BUMPER LAMP',
    subcategory: '램프',
    partNumber: '92201-6A000 L / 92202-6A000 R',
    fullDescription: '현대 MIGHTY EX에 호환되는 범퍼 램프입니다. 순정 규격으로 제작되어 완벽한 호환성을 제공합니다.',
    image: 'https://readdy.ai/api/search-image?query=Hyundai%20Mighty%20EX%20commercial%20truck%20bumper%20lamp%20amber%20lens%20on%20clean%20white%20background%20automotive%20lighting%20spare%20part%20product%20photography%20studio%20lighting%20professional%20shot&width=800&height=1000&seq=hdm002main&orientation=portrait',
    colors: ['#FFA500'],
  }),
  createMightyExProduct({
    id: 'HDM003',
    name: 'HDM003',
    description: 'CORNER LAMP',
    subcategory: '램프',
    partNumber: '92301-6A000 L / 92302-6A000 R',
    fullDescription: '현대 MIGHTY EX에 호환되는 코너 램프입니다. 순정 규격으로 제작되어 완벽한 호환성을 제공합니다.',
    image: 'https://readdy.ai/api/search-image?query=Hyundai%20Mighty%20EX%20commercial%20truck%20corner%20lamp%20indicator%20light%20on%20clean%20white%20background%20automotive%20lighting%20spare%20part%20product%20photography%20studio%20lighting%20professional%20shot&width=800&height=1000&seq=hdm003main&orientation=portrait',
    colors: ['#FFA500'],
  }),
  createMightyExProduct({
    id: 'HDM004',
    name: 'HDM004',
    description: 'CORNER PANEL',
    subcategory: '외장',
    partNumber: '82710-6A000 L / 82720-6A000 R',
    fullDescription: '현대 MIGHTY EX에 호환되는 코너 패널입니다. 순정 규격으로 제작되어 완벽한 호환성을 제공합니다.',
    image: 'https://readdy.ai/api/search-image?query=Hyundai%20Mighty%20EX%20commercial%20truck%20corner%20panel%20fender%20trim%20on%20clean%20white%20background%20automotive%20exterior%20spare%20part%20product%20photography%20studio%20lighting%20professional%20shot&width=800&height=1000&seq=hdm004main&orientation=portrait',
  }),
  createMightyExProduct({
    id: 'HDM005',
    name: 'HDM005',
    description: 'MUDGUARD',
    subcategory: '외장',
    partNumber: '86810-6A000 L / 86820-6A000 R',
    fullDescription: '현대 MIGHTY EX에 호환되는 머드가드입니다. 순정 규격으로 제작되어 완벽한 호환성을 제공합니다.',
    image: 'https://readdy.ai/api/search-image?query=Hyundai%20Mighty%20EX%20commercial%20truck%20mudguard%20fender%20protector%20on%20clean%20white%20background%20automotive%20exterior%20spare%20part%20product%20photography%20studio%20lighting%20professional%20shot&width=800&height=1000&seq=hdm005main&orientation=portrait',
  }),
  createMightyExProduct({
    id: 'HDM006',
    name: 'HDM006',
    description: 'CORNER BUMPER',
    subcategory: '외장',
    partNumber: '86536-6A000 L / 86546-6A000 R',
    fullDescription: '현대 MIGHTY EX에 호환되는 코너 범퍼입니다. 순정 규격으로 제작되어 완벽한 호환성을 제공합니다.',
    image: 'https://readdy.ai/api/search-image?query=Hyundai%20Mighty%20EX%20commercial%20truck%20corner%20bumper%20side%20bumper%20end%20on%20clean%20white%20background%20automotive%20exterior%20spare%20part%20product%20photography%20studio%20lighting%20professional%20shot&width=800&height=1000&seq=hdm006main&orientation=portrait',
  }),
  createMightyExProduct({
    id: 'HDM007',
    name: 'HDM007',
    description: 'SIDE LAMP',
    subcategory: '램프',
    partNumber: '92303-6A000 L / 92304-6A000 R',
    fullDescription: '현대 MIGHTY EX에 호환되는 사이드 램프입니다. 순정 규격으로 제작되어 완벽한 호환성을 제공합니다.',
    image: 'https://readdy.ai/api/search-image?query=Hyundai%20Mighty%20EX%20commercial%20truck%20side%20marker%20lamp%20small%20indicator%20light%20on%20clean%20white%20background%20automotive%20lighting%20spare%20part%20product%20photography%20studio%20lighting%20professional%20shot&width=800&height=1000&seq=hdm007main&orientation=portrait',
    colors: ['#FFA500'],
  }),
  createMightyExProduct({
    id: 'HDM023',
    name: 'HDM023',
    description: 'STRIP',
    subcategory: '외장',
    partNumber: '86315-6A000 / 86325-6A000',
    fullDescription: '현대 MIGHTY EX에 호환되는 스트립입니다. 순정 규격으로 제작되어 완벽한 호환성을 제공합니다.',
    image: 'https://readdy.ai/api/search-image?query=Hyundai%20Mighty%20EX%20commercial%20truck%20decorative%20strip%20trim%20molding%20on%20clean%20white%20background%20automotive%20exterior%20spare%20part%20product%20photography%20studio%20lighting%20professional%20shot&width=800&height=1000&seq=hdm023main&orientation=portrait',
  }),
  createMightyExProduct({
    id: 'HDM019',
    name: 'HDM019',
    description: 'FRONT BUMPER',
    subcategory: '외장',
    partNumber: '86510-6A003',
    fullDescription: '현대 MIGHTY EX에 호환되는 프론트 범퍼입니다. 순정 규격으로 제작되어 완벽한 호환성을 제공합니다.',
    image: 'https://readdy.ai/api/search-image?query=Hyundai%20Mighty%20EX%20commercial%20truck%20front%20bumper%20heavy%20duty%20gray%20on%20clean%20white%20background%20automotive%20exterior%20spare%20part%20product%20photography%20studio%20lighting%20professional%20shot&width=800&height=1000&seq=hdm019main&orientation=portrait',
  }),
];
